export const OrganizationDarkBackground = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <g clipPath="url(#clip0_154_6461)">
      <path
        d="M26.5882 25.1765V22.353H20.4706V20.4445C21.1559 20.3683 21.7924 20.128 22.3398 19.7638C22.2876 19.2423 22.0624 18.7349 21.6638 18.3363C20.7464 17.4189 19.2536 17.4188 18.3362 18.3363C17.9376 18.7349 17.7123 19.2423 17.6602 19.7638C18.2076 20.128 18.8441 20.3683 19.5294 20.4445V22.353H13.4118V25.1765H12V28H15.7647V25.1765H14.3529V23.2941H19.5294V25.1765H18.1176V28H21.8824V25.1765H20.4706V23.2941H25.6471V25.1765H24.2353V28H28V25.1765H26.5882Z"
        fill="#737373"
      />
      <path
        d="M18.5974 17.0191C17.518 15.8319 18.3789 13.8766 19.9993 13.8824C21.6197 13.8765 22.4807 15.8321 21.4013 17.019C22.2295 17.4076 22.8827 18.1402 23.155 19.0568C25.5816 16.3851 23.6447 11.9869 19.9993 12C16.354 11.9869 14.4169 16.3858 16.8437 19.0569C17.1164 18.1388 17.7706 17.407 18.5974 17.0191Z"
        fill="#737373"
      />
      <path
        d="M19.0586 15.7647C19.0586 16.2836 19.4808 16.7058 19.9998 16.7058C21.2484 16.6541 21.248 14.875 19.9998 14.8235C19.4808 14.8235 19.0586 15.2457 19.0586 15.7647Z"
        fill="#737373"
      />
    </g>
    <defs>
      <clipPath id="clip0_154_6461">
        <rect width="16" height="16" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);
